<template>
    <VJoyDialog open class="iframe-container" :confirm-text="t(ctaLabel)" :data-testid="dataTestId" pattern-confirm @dialog:confirm="emit('closed')">
        <template #dialog-preheader>
            <div class="iframe-container">
                <iframe
                    class="discover-malt-strategy-video"
                    height="330"
                    src="https://www.youtube.com/embed/8Vlv8FBsZNQ?si=0lSeJU6QLEB1ZJnl&mute=0&loop=1&modestbranding=1&controls=0?rel=0&playsinline=1"
                    title="Discover Malt Strategy"
                    frameborder="0"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                ></iframe>
            </div>
        </template>

        <template #dialog-header>{{ t(title) }}</template>
        <template #dialog-subheader>
            <div>
                <p>{{ t(content) }}</p>
                <VJoyLink :href="t(link)" :text="t(linkLabel)" target="_blank" />
            </div>
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {useTranslation} from '#imports';
    import {VJoyDialog, VJoyLink} from '@maltjoy/core-vue';
    import type {DialogInfo} from '../jobsSteps';

    defineProps<DialogInfo>();

    const emit = defineEmits<{closed: []}>();

    const {t} = useTranslation();
</script>

<style lang="scss">
    .discover-malt-strategy-video {
        margin-top: -35px;
        margin-left: -35px;
        width: 125%;
    }
</style>
